<template>
    <div :class="styleMain">
        <label>{{ data.name }}</label>
        <span>{{ data.rx }}</span>
        <span>{{ data.tx }}</span>
    </div>
</template>

<script>
export default {
  props: [
    'isTitle',
    'data'
  ],
  computed: {
    styleMain () {
      return [
        'monitoringNetwork',
        {
          'monitoringNetwork--title': this.isTitle
        }
      ]
    }
  }
}
</script>

<style>
.monitoringNetwork{
  display:flex
}

.monitoringNetwork label,
.monitoringNetwork span{
  flex:1;
  color:grey
}

.monitoringNetwork--title label,
.monitoringNetwork--title span{
  color:white
}
</style>
